<template>
  <h1 class="m-h1">Спасибо, что решили выделить время. Для этой благодарности есть даже стартовая страничка...</h1>

  <p class="m-p">Я понимаю, что любую задачу можно качать до бесконечности и недостатков всегда можно найти бесконечное количество, но тем не менее вышло, что вышло</p>


  <p class="m-p">Ссылки сверху кликабельные</p>


  <a href="https://github.com/RuSaG0/game-of-life" target="_blank"> Исходники </a>
</template>

<script>
export default {

}
</script>

<style>

</style>